import { aroApiSlice } from './apiSlice';
import { getBaseURL } from '../../../utilities/config';

// To Do: use baseURL and remove full url from query
export const designApiSlice = aroApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDesign: builder.query({
            query: () => `${getBaseURL()}/design`,
        }),
    }),
});

export const { useGetDesignQuery } = designApiSlice;
